export default __webpack_public_path__ + "static/media/university-icon.674f65a1.png";